<template>
  <div class="video-card-gallery">
    <div class="container">
      <div class="row"></div>
      <div class="row">
        <div class="col-12">
            <slot name="header"></slot>
          <hr />
          <ul class="filters"
          v-if="tags.length > 1"
          >
            <li @click="showAllSlides"
                v-bind:class="{ active: (appliedFilters.length == 0) }">#all</li>
            <li v-for="filter of tags"
                :key="filter"
                v-bind:class="{ active: isFilterActive(filter) }"
                @click="filterSlides(filter)">
              #{{ filter }}
            </li>
          
          </ul>
        </div>
        <div class="col-12">
          <div class="video-gallery">
            <div class="col-lg-4 col-sm-12" v-for="(slide, index) of filteredSlides" :key="index">
                <div class="video-card">
                  <div class="video-card-image" :style="{'background-image' : `url('${getSlideImage(slide)}')`}">
                  </div>
                  <div class="video-card-content">
                    <div>
                      <p class="video-card-title">{{ slide.title }}</p> 
                      <p class="video-card-description">{{ slide.shortDescription }}</p>
                    </div>
                    <div>
                      <a @click.prevent="openVideoModal(slide.ctaUrl)" class="play">
                          Play Video <img loading="lazy" src="https://assets.rhinorack.com/Pages/Polaris/play-btn.png"></a>
                      </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <ul class="navigation" v-if="showNavDots">
            <li class="prev" @click="previousChunk" v-show="showPreviousBtn"></li>
            <li
              class="nav"
              v-for="(chunk, index) of chunkedSlideArray"
              @click="setChunk(index)"
              :key="chunk.index"
              v-bind:class="{ active: index == chuckIndex }"
            ></li>
            <li class="next" @click="nextChunk" v-show="showNextBtn"></li>
          </ul>
        </div>
      </div>
    </div>
    <modal name="youtube-modal" :adaptive="true" height="400px" :scrollable="true" style="display:flex;justify-content:center; align-items:center;">
        <iframe  v-if="youtubeURL" width="100%" height="100%" :src="youtubeURL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="false"></iframe>
    </modal>
  </div>
</template>
    
<script>
export default {
  props: {
    data : {
      type: Object,
    }, 
    chunk_size: {
      type: String,
    }
  },
  data() {
    return {
      slides: null,
      activeSlides: [],
      filteredSlides: [],
      startIndex: 0,
      endIndex: 3,
      chunkSize: 3,
      chuckIndex: 0,
      appliedFilters: [],
      youtubeURL: null,
    };
  },
  created() {
    this.slides = this.data.slides;
    this.activeSlides = this.slides;
    this.chunkSize = Number(this.chunk_size);
    this.endIndex = Number(this.chunk_size);
    this.filteredSlides = this.slides.slice(0, this.chunkSize);
  },
  mounted() {},
  methods: {
    filterSlides(filterName) {
      if (this.isFilterActive(filterName)) {
        this.appliedFilters = this.appliedFilters.filter((filter) => {
          return filter != filterName;
        });
      } else {
        this.appliedFilters.push(filterName);
      }

      this.startIndex = 0;
      this.endIndex = this.chunkSize;
      this.chuckIndex = 0;


      this.reFilter();
      this.filteredSlides = this.activeSlides.slice(
        this.startIndex,
        this.endIndex
      );
    },
    showAllSlides() {
      this.appliedFilters = [];
      this.activeSlides = this.slides;
      this.filteredSlides = this.slides.slice(0, this.chunkSize);
    },
    setChunk(index) {
      this.chuckIndex = index;
      this.filteredSlides = this.chunkedSlideArray[index];
    },
    previousChunk() {
      this.setChunk(this.chuckIndex - 1);
    },
    nextChunk() {
      this.setChunk(this.chuckIndex + 1);
    },
    isFilterActive(filterName) {
      return this.appliedFilters.includes(filterName);
    },
    reFilter() {
      if (this.appliedFilters.length > 0) {
        this.activeSlides = this.slides.filter((slide) => {
          let result = false;
          for (let filter of this.appliedFilters) {
            if (slide.tags && slide.tags.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
              result = true;
            }
          }
          return result;
        });
        this.filteredSlides = this.activeSlides.slice(0, this.chunkSize);
      } else {
        this.showAllSlides();
      }
    },
     openVideoModal(embedCode) {
      this.youtubeURL = "https://www.youtube.com/embed/" + embedCode+'?rel=0';
      this.$modal.show("youtube-modal");
    },
    getSlideImage(slide) {
      return slide.content ? slide.content : `https://img.youtube.com/vi/${slide.ctaUrl}/maxresdefault.jpg`
    }
  },
  computed: {
    chunkedSlideArray() {
      let i, j;
      let chunkedArray = [];

      for (i = 0, j = this.activeSlides.length; i < j; i += this.chunkSize) {
        chunkedArray.push(this.activeSlides.slice(i, i + this.chunkSize));
      }

      return chunkedArray;
    },
    tags() {
      return Object.values(this.data.tags) ?? [];
    },
    showPreviousBtn() {
      return this.chuckIndex > 0;
    },
    showNextBtn() {
      return this.chuckIndex < this.chunkedSlideArray.length - 1;
    },
    showNavDots() {
      return this.chunkedSlideArray.length > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-card-gallery {

  h1,h2,h3,h4,h5,h6 {
    font-family: 'trim-medium';
    text-transform: uppercase;
  }
  .video-gallery {
    display: flex; 
    flex-direction: row; 
    // justify-content: space-between;
    // overflow-x: scroll;
  }
  padding-top: 3rem;
  padding-bottom: 1rem;
  
  .video-card {
    width: unset !important;
    background-color: white;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-right: 1rem;
    min-width: 300px;
    height: 100%;
    margin-bottom: 1rem;
  }
  .video-card-image {
    padding: 33.4%;
    background-size: cover;
    width: 100%;
  }
  .video-card-content {
    height: 100%;
    width: 100%;
    background-color: white;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .video-card-title {
    text-transform: uppercase;
    font-family: "trim-medium";
    font-size: 1.5rem;
    margin-bottom: 0.3rem;
  }
  .video-card-description {
    color: #585858;
    font-family: "trim-regular";
  }
  a {
    text-transform: uppercase;
    font-family: "trim-medium";
    text-decoration: none;
    img {
      width: 2rem;
      margin-left: 0.5rem;
    }
  }
  ul.navigation {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding-left: 0;
    margin-top: 1rem;
    li {
      display: flex;
      margin: 0.5rem;
      justify-content: center;
      align-items: center;
      background-color: lightblue;
      height: 15px;
      width: 15px;
      &.active {
        background-color: #005cb9;
      }
    }
    li.prev {
      background-color: transparent;
      border: solid #353535;
      border-width: 0 3px 3px 0;
      display: inline-block;
      width: 1rem;
      height: 1rem;
      transform: rotate(135deg);
      margin-right: 1rem;
    }
    li.next {
      background-color: transparent;
      border: solid #353535;
      border-width: 0 3px 3px 0;
      display: inline-block;
      width: 1rem;
      height: 1rem;
      transform: rotate(-45deg);
    }
  }
  .slide-fade-enter-active {
    transition: all 1s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  ul.filters {
    padding-left: 0;
    display: flex; 
    list-style-type: none;
    padding-left: 0;
    cursor: pointer;
    flex-wrap: wrap;
    li {
      display: flex;
      padding: 0.5rem;
      margin-right: 1rem;
      justify-content: center;
      align-items: center;
      background-color: lightgrey;
      color: black;
      margin-bottom: .5rem;
      &.active {
        background-color: rgb(0 92 185 / 50%);
        color: #065ab7;
      }
    }
  }
}

</style>